// =====================================================================
// 再入荷通知（LINEで入荷通知）ボタンの挙動分岐
// =====================================================================
// 顧客状態に応じて 3 種のモーダルを開く:
//   - guest          : ログイン誘導モーダル
//   - logged-no-line : LINE ID 連携誘導モーダル
//   - logged-linked  : 確認モーダル → BIS.create() で AMP に直接登録
//
// AMP Back in Stock の iframe モーダルは開かず、公開 JS API を直接呼ぶ。
// CRM PLUS on LINE 側で「再入荷通知をLINEで配信する」が ON の前提。
// 仕様: /Users/wh-dev/.claude/plans/joyful-nibbling-music.md
// =====================================================================

// LINE連携誘導は CRM PLUS バナー (.socialplus-associate-banner-container) を
// programmatically クリックする。バナーが表示されない場合は /account へフォールバック。
// socialplus は公開 JS API を提供していないため、DOM クリック代行が現状唯一の方法。

const MODAL_ID = {
  'guest': 'restock-modal--guest',
  'logged-no-line': 'restock-modal--link-line',
  'logged-linked': 'restock-modal--confirm',
};

const SOCIALPLUS_BANNER_SELECTOR = '.socialplus-associate-banner-container';
const FALLBACK_LINE_LINK_URL = '/account';

// ステートマシン: ユーザーがログイン or LINE連携で離脱する直前に
// 「どの variant の通知登録を進めていたか」を localStorage に保存する。
// 戻ってきた時に DOMContentLoaded で resume を読み、現在の customer_state に応じて
// 次のモーダルを自動で開く（押し直し不要）。
//   - guest 離脱直後（ログイン誘導）  → 戻った時 logged-no-line なら連携誘導モーダル
//   - logged-no-line 離脱直後（連携誘導） → 戻った時 logged-linked なら確認モーダル
//   - logged-linked になれば resume を消費
const RESUME_STORAGE_KEY = 'restock_pending_resume';
const RESUME_TTL_MS = 5 * 60 * 1000;

let activeRequest = null;

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-restock-trigger]');
  if (trigger) {
    event.preventDefault();
    handleTriggerClick(trigger);
    return;
  }
  const loginLink = event.target.closest('[data-restock-login-link]');
  if (loginLink) {
    // preventDefault しない（通常のリンク遷移で /account/login へ）
    saveResume();
    return;
  }
  const lineLink = event.target.closest('[data-restock-line-link-url]');
  if (lineLink) {
    event.preventDefault();
    saveResume();
    triggerLineIdLink();
    return;
  }
  const submit = event.target.closest('[data-restock-submit]');
  if (submit && activeRequest) {
    event.preventDefault();
    submitRestock(activeRequest);
  }
});

// ページロード時にステートマシンの resume を試行
document.addEventListener('DOMContentLoaded', tryResume);

function handleTriggerClick(trigger) {
  const state = trigger.dataset.customerState;
  const modalId = MODAL_ID[state];
  if (!modalId) return;

  activeRequest = {
    email: trigger.dataset.customerEmail,
    variantId: trigger.dataset.variantId,
    productId: trigger.dataset.productId,
  };

  if (state === 'logged-linked') {
    openConfirmModalDefault();
  }

  const modal = document.getElementById(modalId);
  if (modal && typeof modal.show === 'function') modal.show();
}

function triggerLineIdLink() {
  const banner = document.querySelector(SOCIALPLUS_BANNER_SELECTOR);
  if (banner && banner.offsetParent !== null) {
    banner.click();
    return;
  }
  window.location.href = FALLBACK_LINE_LINK_URL;
}

function saveResume() {
  if (!activeRequest) return;
  try {
    localStorage.setItem(RESUME_STORAGE_KEY, JSON.stringify({
      path: location.pathname,
      variantId: activeRequest.variantId,
      productId: activeRequest.productId,
      savedAt: Date.now(),
    }));
  } catch (e) {
    // localStorage が使えない環境では諦める
  }
}

function clearResume() {
  try { localStorage.removeItem(RESUME_STORAGE_KEY); } catch (e) {}
}

function tryResume() {
  let resume;
  try {
    const raw = localStorage.getItem(RESUME_STORAGE_KEY);
    if (!raw) return;
    resume = JSON.parse(raw);
  } catch (e) {
    clearResume();
    return;
  }

  if (!resume || Date.now() - resume.savedAt > RESUME_TTL_MS) {
    clearResume();
    return;
  }
  // 別ページに飛んでいる時は resume を残しておく（同じ商品ページに戻ってきたら復活）
  if (resume.path !== location.pathname) return;

  const trigger = document.querySelector(
    `[data-restock-trigger][data-variant-id="${CSS.escape(String(resume.variantId))}"]`
  );
  if (!trigger) return;

  const state = trigger.dataset.customerState;
  activeRequest = {
    email: trigger.dataset.customerEmail,
    variantId: trigger.dataset.variantId,
    productId: trigger.dataset.productId,
  };

  if (state === 'logged-linked') {
    // ゴール到達：確認モーダルを自動表示して resume を消費
    clearResume();
    openConfirmModalDefault();
    const modal = document.getElementById('restock-modal--confirm');
    if (modal && typeof modal.show === 'function') modal.show();
  } else if (state === 'logged-no-line') {
    // 中間ステップ：ログインは済んだが未連携。連携誘導モーダルを自動表示。
    // resume は維持（次の連携完了後に消費するため）
    const modal = document.getElementById('restock-modal--link-line');
    if (modal && typeof modal.show === 'function') modal.show();
  } else {
    // guest のまま戻ってきた = ログイン失敗 or 別ユーザー。resume クリアして終了。
    clearResume();
  }
}

function openConfirmModalDefault() {
  setConfirmState('default');
  const emailEl = document.querySelector('[data-restock-confirm-email]');
  if (emailEl && activeRequest) emailEl.textContent = activeRequest.email;
  setConfirmHeader('再入荷通知を受け取る');
  setSubmitVisible(true);
}

function submitRestock({ email, variantId, productId }) {
  if (!window.BIS || typeof window.BIS.Base !== 'function') {
    showError('再入荷通知サービスを読み込めませんでした。時間を置いて再度お試しください。');
    return;
  }
  const base = new window.BIS.Base();
  base.onSuccess = () => showSuccess(email);
  base.onError = (errors) => {
    const msg = Array.isArray(errors) && errors.length > 0
      ? errors.join(' / ')
      : '登録に失敗しました。時間を置いて再度お試しください。';
    showError(msg);
  };
  base.create(email, variantId, productId, {});
}

function showSuccess(email) {
  setConfirmHeader('登録完了');
  setConfirmState('success');
  const successEmailEl = document.querySelector('[data-restock-success-email]');
  if (successEmailEl) successEmailEl.textContent = email;
  setSubmitVisible(false);
}

function showError(msg) {
  setConfirmHeader('登録できませんでした');
  setConfirmState('error');
  const errorEl = document.querySelector('[data-restock-error-text]');
  if (errorEl) errorEl.textContent = msg;
  setSubmitVisible(false);
}

function setConfirmState(stateName) {
  document.querySelectorAll('[data-restock-state]').forEach((el) => {
    el.hidden = el.dataset.restockState !== stateName;
  });
}

function setConfirmHeader(text) {
  const el = document.querySelector('[data-restock-confirm-header]');
  if (el) el.textContent = text;
}

function setSubmitVisible(visible) {
  const el = document.querySelector('[data-restock-submit]');
  if (el) el.style.display = visible ? '' : 'none';
}
